import { useTranslation } from "react-i18next";

function SubscriptionStatusBadge({ status, ...props }) {
  const { t } = useTranslation("general");

  return (
    <div className={`c-subscription-badge ${status.toLowerCase()}`} {...props}>
      {t(status.toLocaleLowerCase())}
    </div>
  );
}

export default SubscriptionStatusBadge;